// extracted by mini-css-extract-plugin
module.exports = {"title_wrapper":"styles_title_wrapper__HEJ77","confirmDelete":"styles_confirmDelete__39sGm","btn_delete":"styles_btn_delete__14sJE"};